import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@americanexpress/dls-react';
import styles from './inavLite.scss';
import QuitModal from './QuitModal';

const InavLite = ({
  languageData,
  modalData,
  CustomModal,
  // eslint-disable-next-line complexity -- multiple conditional branches handle modal/exit-button variations across markets
}) => {
  const [show, setShow] = useState(false);
  const {
    redirectionUrl,
    leaveApplication,
    logoRedirectionUrl,
  } = languageData;

  const redirectToLandingPage = () => {
    window.location.href = redirectionUrl;
  };

  const exitButtonReactlytics = modalData?.modalProps?.exitButtonReactlytics || {
    element: 'ExitButton',
    detail: 'Header',
  };

  const actionOnHeaderExit = () => {
    if (modalData.show) {
      return setShow(true);
    }
    return redirectToLandingPage();
  };

  const ModalComponent = CustomModal ?? QuitModal;
  const modalDetails = {
    ...modalData?.modalProps,
    title: modalData?.modalProps?.modalTitle,
    content: modalData?.modalProps?.modalBody,
    handleActionsOnExit: modalData?.modalProps?.handleActionsOnExit,
    setShow,
    redirectToLandingPage,
  };

  const renderExitButton = () => (
    <div className="flex-justify-end col-md-3 col-sm-5 col-xs-5 text-align-right">
      <Button
        variant="tertiary"
        className={`pad-0 position-absolute-tr-xs-up margin-4-r text-underline dls-white-bg ${styles.cursorPointer} ${styles.exitBtn}`}
        onClick={actionOnHeaderExit}
        {...{
          reactlytics: exitButtonReactlytics,
        }}
      >
        {modalData?.modalProps?.exitTextInHeader || leaveApplication}
      </Button>
    </div>
  );

  return (
    <>
      <div className="width-full dls-white-bg">
        <header id="simplified-header">
          <div className={styles.inavHeight} />
          <div className={`flex width-full pad-1-t pad-2-b ${styles.inavLite} ${!modalData?.showExitButtonInHeader ? 'flex-justify-center' : ''}`}>
            <div className={`flex-justify-center col-md-6 ${modalData?.showExitButtonInHeader ? 'col-md-offset-3' : ''} col-sm-7 col-xs-7 text-align-center-sm-down text-align-center-md-up margin-1-t flex-item-grow`}>
              <a href={logoRedirectionUrl || undefined} style={{ cursor: logoRedirectionUrl ? 'pointer' : 'unset !important' }} className={`${modalData?.showExitButtonInHeader ? 'hidden-sm-down' : ''}`}>
                <img
                  className={`${styles.logoLine} desktop-logo`}
                  src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/logos/dls-logo-line.svg"
                  alt="American Express"
                />
              </a>
              <a href={logoRedirectionUrl || undefined} className={`${!modalData?.showExitButtonInHeader ? 'hidden' : 'hidden-md-up'}`}>
                <img
                  src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/logos/dls-logo-stack.svg"
                  alt="American Express"
                  className={styles.mobileLogo}
                />
              </a>
            </div>
            {modalData?.showExitButtonInHeader ? renderExitButton() : null}
          </div>
        </header>
      </div>
      {show && (
        <ModalComponent
          languageData={languageData}
          modalDetails={modalDetails}
        />
      )}
    </>
  );
};

InavLite.propTypes = {
  languageData: PropTypes.objectOf(PropTypes.string),
  modalData: PropTypes.objectOf(PropTypes.string),
  CustomModal: PropTypes.elementType,
};

export default InavLite;
